import Splide from "@splidejs/splide";
console.log("bundled ajax-product-explore v1.0");
window.addEventListener("load", function () {
  const productExplorerSelect = document.getElementById("product-explorer");

  const productExplorerCategories = document.querySelectorAll(
    ".product-explorer-category"
  );

  if (productExplorerSelect || productExplorerCategories) {
    const ajaxUrl = "/wp-admin/admin-ajax.php";

    const productExplorerResults = document.getElementById(
      "product-explorer-results"
    );

    let initialCategoryId = "";

    // const setInitialCategoryId = () => {
    if (productExplorerSelect) {
      initialCategoryId =
        productExplorerSelect.getAttribute("data-initial-category-id") || "";
    } else if (productExplorerCategories.length > 0) {
      initialCategoryId = productExplorerCategories[0].id || "";
    }
    console.log("Initial Category ID set to:", initialCategoryId);
    //};

    // setTimeout(setInitialCategoryId, 50);

    const fetchProducts = (categoryId) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", ajaxUrl, true);
      xhr.setRequestHeader(
        "Content-Type",
        "application/x-www-form-urlencoded; charset=UTF-8"
      );

      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 400) {
          if (productExplorerResults) {
            productExplorerResults.innerHTML = xhr.responseText;

            const productExplorerSlider = document.getElementById(
              "product-explorer-slider"
            );
            if (productExplorerSlider) {
              const explorerSlider = new Splide(productExplorerSlider, {
                type: "slide",
                perPage: 1,
                perMove: 1,
                gap: 16,
                focus: "center",
                rewind: true,
                arrows: true,
                pagination: true,
                mediaQuery: "min",
                breakpoints: {
                  768: {
                    perPage: 3,
                    perMove: 3,
                    pagination: false,
                  },
                  992: {
                    gap: 24,
                  },
                  1920: {
                    gap: 32,
                  },
                },
              });
              explorerSlider.on("mounted", function () {
                // if fewer slides than provided in options, set option to the number of slides
                const slideCount = explorerSlider.Components.Slides.getLength();
                if (
                  slideCount <= explorerSlider.options.breakpoints[768].perPage
                ) {
                  explorerSlider.options.breakpoints[768].perPage = slideCount;
                  explorerSlider.options.focus = 0;
                  explorerSlider.options.arrows = false; // arrow set to false but still display: need css checked
                  explorerSlider.refresh();
                }
              });
              explorerSlider.mount();
            }
          }
        } else {
          console.error("Error fetching products");
        }
      };

      xhr.onerror = function () {
        console.error("Request failed");
      };

      xhr.send(
        "action=get_product_explorer_by_category&category_id=" + categoryId
      );
    };

    fetchProducts(initialCategoryId);

    if (productExplorerSelect) {
      productExplorerSelect.addEventListener("change", function () {
        fetchProducts(this.value);
      });

      productExplorerCategories.forEach((category) => {
        if (category.id === initialCategoryId) {
          category.classList.add("active");
        }
      });
    }

    if (productExplorerCategories) {
      productExplorerCategories.forEach((category) => {
        category.addEventListener("click", function () {
          productExplorerCategories.forEach(function (el) {
            el.classList.remove("active");
          });

          const categoryId = this.id;
          this.classList.add("active");
          fetchProducts(categoryId);
        });
      });
    }
  }
});
